import script from "./BaseTextarea.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseTextarea.vue?vue&type=script&setup=true&lang=ts"

import "./BaseTextarea.vue?vue&type=style&index=0&id=76ebbb38&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76ebbb38"]])

export default __exports__